__turbopack_context__.v({
  "carousel": "SecPlatformPortfolio-module-scss-module__7DTMva__carousel",
  "carouselInner": "SecPlatformPortfolio-module-scss-module__7DTMva__carouselInner",
  "carouselWrap": "SecPlatformPortfolio-module-scss-module__7DTMva__carouselWrap",
  "container": "SecPlatformPortfolio-module-scss-module__7DTMva__container",
  "description": "SecPlatformPortfolio-module-scss-module__7DTMva__description",
  "enter": "SecPlatformPortfolio-module-scss-module__7DTMva__enter",
  "exit": "SecPlatformPortfolio-module-scss-module__7DTMva__exit",
  "fade-in": "SecPlatformPortfolio-module-scss-module__7DTMva__fade-in",
  "fade-out": "SecPlatformPortfolio-module-scss-module__7DTMva__fade-out",
  "fade-out-80": "SecPlatformPortfolio-module-scss-module__7DTMva__fade-out-80",
  "fadeLeft": "SecPlatformPortfolio-module-scss-module__7DTMva__fadeLeft",
  "fadeRight": "SecPlatformPortfolio-module-scss-module__7DTMva__fadeRight",
  "glow": "SecPlatformPortfolio-module-scss-module__7DTMva__glow",
  "heading": "SecPlatformPortfolio-module-scss-module__7DTMva__heading",
  "headingBlock": "SecPlatformPortfolio-module-scss-module__7DTMva__headingBlock",
  "logoInner": "SecPlatformPortfolio-module-scss-module__7DTMva__logoInner",
  "logoLayer": "SecPlatformPortfolio-module-scss-module__7DTMva__logoLayer",
  "logoLayerBlack": "SecPlatformPortfolio-module-scss-module__7DTMva__logoLayerBlack",
  "logoRow": "SecPlatformPortfolio-module-scss-module__7DTMva__logoRow",
  "logoSlot": "SecPlatformPortfolio-module-scss-module__7DTMva__logoSlot",
  "logoStack": "SecPlatformPortfolio-module-scss-module__7DTMva__logoStack",
  "publicLine": "SecPlatformPortfolio-module-scss-module__7DTMva__publicLine",
  "publicLineSecond": "SecPlatformPortfolio-module-scss-module__7DTMva__publicLineSecond",
  "publicOverlay": "SecPlatformPortfolio-module-scss-module__7DTMva__publicOverlay",
  "section": "SecPlatformPortfolio-module-scss-module__7DTMva__section",
  "slide-in-from-bottom": "SecPlatformPortfolio-module-scss-module__7DTMva__slide-in-from-bottom",
  "slide-in-from-left": "SecPlatformPortfolio-module-scss-module__7DTMva__slide-in-from-left",
  "slide-in-from-right": "SecPlatformPortfolio-module-scss-module__7DTMva__slide-in-from-right",
  "slide-in-from-top": "SecPlatformPortfolio-module-scss-module__7DTMva__slide-in-from-top",
  "slide-out-to-bottom": "SecPlatformPortfolio-module-scss-module__7DTMva__slide-out-to-bottom",
  "slide-out-to-left": "SecPlatformPortfolio-module-scss-module__7DTMva__slide-out-to-left",
  "slide-out-to-right": "SecPlatformPortfolio-module-scss-module__7DTMva__slide-out-to-right",
  "slide-out-to-top": "SecPlatformPortfolio-module-scss-module__7DTMva__slide-out-to-top",
  "zoom-in": "SecPlatformPortfolio-module-scss-module__7DTMva__zoom-in",
  "zoom-out": "SecPlatformPortfolio-module-scss-module__7DTMva__zoom-out",
});
